import axios from "axios";
import { api } from "./api_route";

export const createClaimantCounselAPI = async (claimantCounselData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      claimantCounselData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/claimantCounsel/create`,
      claimantCounselData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getClaimantCounselByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(`${api}/claimantCounsel/case/${caseID}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateClaimantCounselAPI = async (
  claimantCounselID,
  claimantCounselData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      claimantCounselData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/claimantCounsel/update/${claimantCounselID}`,
      claimantCounselData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteClaimantCounselAPI = async (claimantCounselID) => {
  try {
    const response = await axios.delete(
      `${api}/claimantCounsel/delete/${claimantCounselID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteClaimantCounselDocumentAPI = async (documentID) => {
  try {
    const response = await axios.delete(
      `${api}/claimantCounsel/document/delete/${documentID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const claimantCounselDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/claimantCounselDocuments/${values.original.documentNewName}`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
};
// Document Categories Constants
export const CLAIMANTCOUNSEL_DOCUMENT_CATEGORIES = {
  BARCOUNCILCERTIFICATE: 1243,
  VAKALTH: 1242,
};

export const DOCUMENT_CATEGORY_LABELS = {
  1243: "Bar Council Certificate",
  1242: "Vakalatnama",
};
